import { FormattedMessage as FM } from "react-intl";

import { ArrowRightIcon } from "components/Icons";

function PreviewCard({ colors, index }) {
  return (
    <div
      className="flex items-center justify-between gap-2 rounded-lg border p-2.5"
      style={{ borderColor: colors.border_color }}
    >
      <div className="min-w-0">
        <p
          className="text-[9px] font-semibold uppercase tracking-wider"
          style={{ color: colors.accent_color }}
        >
          <FM id="melhous.dash.preview.card_action" />
        </p>
        <p className="truncate text-xs font-semibold">
          <FM id="melhous.dash.preview.card" /> {index}
        </p>
      </div>
      <ArrowRightIcon width={14} className="shrink-0 fill-current" />
    </div>
  );
}

export default PreviewCard;
